export default class OkendoIntercom {
  constructor() {
    if (!window.Intercom) return;
    const $els = document.querySelectorAll(".js-invoke-intercom, [href='#js-invoke-intercom']");
    $els.forEach($el => {
      $el.addEventListener('click', (e) => {
        e.preventDefault();
        Intercom('showNewMessage')
      });
    });
  }
}
